<template>
  <div class="home">
    <RequestThankYouPage />
  </div>
</template>

<script>
import RequestThankYouPage from '../components/elements/pages/RequestThankYouPage.vue'
export default {
  name: 'RequestKitsThankYou',
  metaInfo: {
    title: 'Request Kits Thank You'
  },
  components: {
    RequestThankYouPage
  }
}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
</style>
